export const MONDIALI_SHARE_TITLE = 'ALMA Giochini Mondiali';
export const MONDIALI_SHARE_TEXT = 'Unisciti ai roster di ALMA Giochini Mondiali.';
export const MONDIALI_SHARE_SUCCESS_MESSAGE = 'Invito condiviso.';
export const MONDIALI_SHARE_ERROR_MESSAGE = 'Impossibile condividere il link.';
export const MONDIALI_RESULTS_SHARE_SUCCESS_MESSAGE = 'Risultato condiviso.';
export const MONDIALI_RESULTS_SHARE_ERROR_MESSAGE = 'Impossibile condividere il risultato.';

export const getMondialiShareUrl = (path = '/mondiali') => (
  typeof window !== 'undefined'
    ? `${window.location.origin}${path}`
    : path
);

export const getMondialiResultsShareText = (stellineTotal) => {
  const normalizedTotal = Number(stellineTotal);
  const formattedTotal = Number.isFinite(normalizedTotal)
    ? new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(Math.max(0, normalizedTotal))
    : null;

  if (!formattedTotal) {
    return 'Ho partecipato ad ALMA Giochini Mondiali. Scopri i risultati finali! #Mondiali #GiochinidiParole';
  }

  return `Ho conquistato ${formattedTotal} stelline durante ALMA Giochini Mondiali. Scopri i risultati finali! #Mondiali #GiochinidiParole`;
};

export const showMondialiShareSnackbar = (message, type = 'success') => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent('global-snackbar', {
    detail: {
      message,
      type,
      duration: 3200,
    },
  }));
};
